<template>
  <section class="auth-page">
    <div class="content">
      <h2>Reddit数据分析系统</h2>
      <div class="text">
        {{ loginLoading ? '认证中~' : '认证失效，请重新认证~' }}
      </div>
      <el-button
        class="login-btn"
        @click.native.prevent="handleLogin"
        :loading="loginLoading"
      >
        认 证
      </el-button>
    </div>
  </section>
</template>
<script>
import { oauthLoginApi, authUrlApi } from '@/api/oauth'
export default {
  data() {
    return {
      loginLoading: false
    }
  },
  async created() {
    localStorage.setItem('origin', this.$route.path)
    const { code, idToken } = this.getHash()
    if (code && idToken) {
      this.loginFun(code, idToken)
    }
    if (this.$route.query.autoLogin == 'true') {
      const urlResponce = await this.getUrl()
      if (urlResponce) {
        window.location.href = urlResponce
      }
    }
  },
  methods: {
    async handleLogin() {
      const urlResponce = await this.getUrl()
      if (urlResponce) {
        window.location.href = urlResponce
      }
    },
    // 登录
    async loginFun(code, idToken) {
      try {
        this.loginLoading = true
        const res = await oauthLoginApi({
          code: code,
          idToken: idToken,
          providerName: this.getProviderName()
        })
        window.localStorage.setItem('roles', res.roles)
        sessionStorage.setItem('userInfo', JSON.stringify(res))
        this.$store.commit('user/SET_INFO')
        this.$router.push('/')
      } catch (e) {
        this.loginLoading = false
      }
    },
    //获取登录地址
    async getUrl() {
      try {
        const res = await authUrlApi(this.getProviderName())
        return res
      } catch {
        return ''
      }
    },
    // 获取认证后的url信息
    getHash() {
      const query = new URLSearchParams(this.$route.hash.slice(1))
      const code = query.get('code') || null
      const idToken = query.get('id_token') || null
      return {
        code: code,
        idToken: idToken
      }
    },
    // 获取平台名称
    getProviderName() {
      let name = this.$route.params.platformName
      return name || ''
    }
  }
}
</script>
<style lang="scss" scoped>
$bg: #456da2;

.auth-page {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  // background: url('../assets/imgs/bg.webp') no-repeat center;

  // background-size: 100% 100%;

  .content {
    width: 380px;
    height: 380px;
    background: #ffffffbd;
    border-radius: 10px;
    box-shadow: 0 0 10px 4px #cfcfcf;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    padding-bottom: 40px;
    box-sizing: border-box;

    h2 {
      font-size: 26px;
    background: #f74300;
    color: #fff;
    width: 100%;
    text-align: center;
    margin: 0;
    padding: 20px;
    }

    .text {
      color: #9b9c9c;
    }

    .login-btn {
      background: #f74300;
      border: 1px solid #f74300;
      color: #fff;
      font-size: 16px;
      letter-spacing: 2px;
      width: 40%;
      border-radius: 40px;
    }
  }

  /* 模糊背景层 */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('../assets/loginImages/bg.jpg') no-repeat center;
    background-size: 100% 100%;

    /* 透明度 0.7 */
    z-index: -1;
    /* 置于内容下方 */
  }
}
</style>
